import ModalMobile from "../../../../components/shared/Modal/ModalMobile";
import React, { useEffect, useState } from "react";
import { MdCheck } from "react-icons/md";
import Divider from "../../../../components/shared/Divider/Divider";
import { FiArrowUpRight } from "react-icons/fi";
import {
  listOfSubscriptionNames,
  listOfSubscriptions,
  plansEnvConfig,
} from "../../../../common/envConfig";
import ProratedInfo from "./ProratedInfo";
import { planProrationEligibility } from "../../../../components/stripeSubscription/utils/discountedPrice";

export default function WarningModal({
  isOpen,
  onCancel,
  onConfirm,
  subscriptionData,
  addOn,
  selectedPlan,
}) {
  //  const isUpgradingToPlus = planProrationEligibility(
  //     subscriptionData.oldSubscription?.productId || subscriptionData.productId,
  //     selectedPlan
  //   );

  const isUpgradingToPlus = planProrationEligibility(
    subscriptionData?.productId,
    selectedPlan
  );

  const isNewSubMonthly = selectedPlan?.includes("monthly");

  return (
    <ModalMobile
      className="pt-12 font-manrope w-full max-w-[620px]"
      isOpen={isOpen}
      onClose={onCancel}
      showClose={true}
    >
      {/* <div>{subscriptionData.productId}</div>
      <div>{selectedPlan}</div> */}

      {isUpgradingToPlus && (
        <>
          <div className="px-6 flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <div className="size-6 min-w-6 flex items-center justify-center bg-success100 p-1.5 rounded-full">
                <MdCheck className="w-full text-success600" />
              </div>
              <p className="text-black text-lg font-semibold">Current plan</p>
            </div>

            <ProratedInfo
              subscriptionData={subscriptionData}
              selectedPlan={selectedPlan}
            />
          </div>

          <Divider className="my-4" color="gray200" type="horizontal"/>
        </>
      )}

      <div className="px-6">
        <div className="flex items-center gap-2">
          <div className="size-6 min-w-6 flex items-center justify-center bg-primary100 p-1.5 rounded-full">
            <FiArrowUpRight className="w-full text-primary600" />
          </div>
          <p className="text-black text-lg font-semibold">New plan</p>
        </div>

        <div className="mt-3 text-gray600 text-sm">
          You’ve selected the{" "}
          <span className="font-bold">
            {listOfSubscriptionNames[selectedPlan]}
          </span>
          , billed {isNewSubMonthly ? "monthly" : "yearly"} at $
          {plansEnvConfig[selectedPlan] +
            (addOn ? (isNewSubMonthly ? 40 : 400) : 0)}{" "}
          per {isNewSubMonthly ? "month" : "year"}
        </div>

        <div className="mt-4 bg-gray100 rounded-lg p-4 flex flex-col gap-1">
          <p className="text-black text-xs font-bold">
            To Apple or Google Subscribers
          </p>

          <div className="text-grayTrue700 text-xs font-semibold">
            You need to{" "}
            <a
              href="https://help.sportsbox.ai/how-do-i-cancel-my-sportsbox-3dgolf-subscription"
              target="_blank"
              rel="noopener noreferrer"
              className="text-warning600 hover:underline"
            >
              cancel the current Apple or Google subscription
            </a>{" "}
            or immediately or you will continue to be charged. It is your
            responsibility to cancel your current plan
          </div>
        </div>
        {/* {subIsActive ? (
          <div className="mt-4 bg-gray100 rounded-lg p-4 flex flex-col gap-1">
            <p className="text-black text-xs font-bold">Important Notice</p>
            <div className="text-grayTrue700 text-xs font-semibold">
              You currently have an active subscription. After clicking Continue
              to payment details, your current subscription will be canceled
              immediately as part of the upgrade process. You must complete the
              entire payment flow to activate your new plan — if you exit midway
              or close the window, your previous subscription will not remain
              active.
            </div>
          </div>
        ) : (
          <></>
        )} */}
      </div>

      <div className="flex items-center justify-between gap-3 p-6">
        <button
          onClick={onCancel}
          className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnGray100"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500"
        >
          Continue to payment details
        </button>
      </div>
    </ModalMobile>
  );
}
